<h3 [innerHTML]="title" [attr.icon]="icon" [id]="id"></h3>